import { Action } from 'redux';

import ngRedux from 'ng-redux';

import { ProjectItem } from './project';
import { AppStates, WorldItem } from './world';

export const WORLD_INITIAL: WorldItem = {
  appState: AppStates.DRAFT,
  language: 'en',
  countryCode: 'us',
  customerType: 'b2ccmgt',
  ruleVersion: '0.0.0',
  sequenceCodes: [],
  vocabulary: {},
  templateColumnDefs: [],
  templateSupportedExtensions:  ['.xls', '.csv', '.txt'],
  maxNoOfOligos: 200,
  clientConfig: {
    addToCartMode: 'server',
    tombstoneStart: 10,
    alertLevel: 'error',
    checkSessionOnLanding: true,
    storageEncoding: 'none',
    productFamilySku: '10336022',
    cartRedirectDelaySecs: 2,
  },
};

export const ScopeEvents: {
  ERROR: string;
  CART_ADD: string;
  BULK_UPLOAD_SHOW: string;
  BULK_UPLOAD_IMPORT: string;
} = {
  ERROR: 'error',
  CART_ADD: 'cart-add',
  BULK_UPLOAD_SHOW: 'bulk-upload-show',
  BULK_UPLOAD_IMPORT: 'bulk-upload-import',
};

export type ProjectItemOrNull = ProjectItem | null;

export type RootState = {
  projects: ProjectItem[];
  world: WorldItem;
};

export interface ReduxAction<T extends any> extends Action<string> {
  payload: T;
}

export interface INgRedux extends ngRedux.INgRedux {
  /* tslint:disable:ban-types */
  connect(mapStateToTarget: ((state: any) => Object) | null,
          mapDispatchToTarget?: Object | ((dispatch: Function) => Object)): (target: Function | Object) => () => void;
}

export type BootstrapModalOptions = {
  backdrop?: boolean | string;
  keyboard?: boolean;
  show?: boolean;
  remote?: string;
};

export type BootstrapModal = {
  (option: string | BootstrapModalOptions): void;
  Constructor: {
    VERSION: string;
    prototype: {
      enforceFocus(): void;
    };
  };
};

export type BootstrapPopoverOptions = {
  html: boolean;
  placement: string;
  trigger: string;
  content?: string;
};

export type BootstrapPopover = (option: string | BootstrapPopoverOptions) => void;

export type BootstrapJQ = {
  modal: BootstrapModal;
  popover: BootstrapPopover;
} & JQuery<HTMLElement>;

export type CreateStorageMiddleware = (settings: { key: string; type: string; }) => ngRedux.Middleware;

export type GetInitialStorageState<T> = ($q: ng.IQService, settings: { key: string; type: string; defaultResponse: RootState}) => T;

export * from './properties';
export * from './param-def';
export * from './project';
export * from './richDropdown';
export * from './sequenceTextbox';
export * from './i18n';
export * from './world';
export * from './client';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0-0!./src/main/script/models/index.ts